(function () {
  function isolateDrawer() {
    const drawer = document.querySelector('.product-upsells__drawer');
    if (!drawer) return;

    const drawerVariantPickers = drawer.querySelectorAll('variant-picker');
    drawerVariantPickers.forEach(function (picker) {
      picker.removeAttribute('data-template-product-match');
      picker.setAttribute('data-drawer-isolated', 'true');

      const pickerElement = /** @type {any} */ (picker);
      if (typeof pickerElement.variantChanged === 'function') {
        const originalVariantChanged = pickerElement.variantChanged.bind(pickerElement);
        pickerElement.variantChanged = function (/** @type {Event} */ event) {
          if (event) {
            event.stopPropagation();
          }
          return originalVariantChanged(event);
        };
      }
    });

    const drawerBuyButtons = drawer.querySelectorAll('product-form-component');
    drawerBuyButtons.forEach(function (form, index) {
      form.setAttribute('data-drawer-isolated', 'true');

      const formElement = form.querySelector('form');
      if (formElement && formElement.id) {
        const originalId = formElement.id;
        formElement.id = 'drawer-' + originalId + '-' + index;

        const formIdInputs = form.querySelectorAll('[form="' + originalId + '"]');
        formIdInputs.forEach(function (input) {
          input.setAttribute('form', formElement.id);
        });
      }
    });

    drawer.addEventListener(
      'variant:update',
      function (event) {
        const eventTarget = event.target;
        if (eventTarget instanceof HTMLElement && drawer.contains(eventTarget)) {
          event.stopPropagation();
        }
      },
      false
    );

    drawer.addEventListener(
      'variant:selected',
      function (event) {
        const eventTarget = event.target;
        if (eventTarget instanceof HTMLElement && drawer.contains(eventTarget)) {
          event.stopPropagation();
        }
      },
      false
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', isolateDrawer);
  } else {
    isolateDrawer();
  }

  const observer = new MutationObserver(function (mutations) {
    const drawer = document.querySelector('.product-upsells__drawer[open]');
    if (drawer) {
      requestAnimationFrame(function () {
        isolateDrawer();
      });
      observer.disconnect();
    }
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
  });

  document.addEventListener('dialog:open', function (event) {
    if (
      event.target &&
      event.target instanceof HTMLElement &&
      event.target.classList.contains('product-upsells__drawer')
    ) {
      requestAnimationFrame(function () {
        isolateDrawer();
      });
    }
  });
})();
